import React from 'react';
import cx from 'classnames';
// import PropTypes from 'prop-types'
import { StatusStyled } from './styled';

const Status = ({ theme_standard, label, color }) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });
  return (
    <StatusStyled color={color}>
      <div className={customClass}>
        <div className="status_label">{label}</div>
      </div>
    </StatusStyled>
  );
};

Status.propTypes = {};

export default Status;
